<template>
  <div
    v-if="
      productPageStore.isFamilyPlanSet &&
      productPageStore.productState.familyPlanDetails?.familyPlanSummaryItems &&
      productPageStore.productState.familyPlanDetails?.familyPlanSummaryItems
        .length > 0
    "
    class="flex flex-col rounded-md border-2 border-border-secondary p-16 mb-24"
    :class="[animatedElementRootClass, animatedElementTransitionClasses]"
  >
    <ul class="border-b-2 border-border-tertiary">
      <PdpFamilySummaryTablePlanRow
        v-for="(familyPlanBundlePrice, index) of productPageStore.productState
          .familyPlanDetails?.familyPlanSummaryItems"
        :key="familyPlanBundlePrice.BundlePriceId + index"
        :name="getPlanName(familyPlanBundlePrice, index)"
        :img-src="
          images_selectImageUrlForSubscriptionItemInList(
            familyPlanBundlePrice.Plan?.DataAllowance
              ? `${familyPlanBundlePrice.Plan?.DataAllowance}`
              : undefined,
            familyPlanBundlePrice.Plan?.RegularDataAllowance
              ? `${familyPlanBundlePrice.Plan?.RegularDataAllowance}`
              : undefined,
            undefined,
            familyPlanBundlePrice.Plan?.IsFamilyPlan,
          )
        "
        :regular-price="familyPlanBundlePrice?.Plan?.RegularMonthlyFee"
        :price="familyPlanBundlePrice?.Plan?.MonthlyFee"
        :bind-period="+productPageStore.selectedBindingPeriod"
        :offer-validity-in-months="
          familyPlanBundlePrice?.Plan?.OfferValidityInMonthsDiscount
        "
        :data-allowence="familyPlanBundlePrice.Plan?.DataAllowance"
        :regaular-data-allowence="
          familyPlanBundlePrice.Plan?.RegularDataAllowance
        "
      />
    </ul>
    <div class="flex w-full justify-between my-8">
      <p class="heading-xxs">Totalt:</p>
      <div
        v-if="productPageStore.ui.loading.isFamilySummaryTableLoading"
        class="motion-safe:animate-pulse motion-reduce:animate-none"
      >
        <span class="w-95 h-22 mb-2 bg-text-disabled block"></span>
      </div>
      <p v-else class="heading-xxs">
        {{
          productPageStore.productState.familyPlanDetails
            .familyPlansTotalMonthlyFee
        }}
        kr/mån
      </p>
    </div>
    <button
      aria-label="Ändra valda familjeabonnemang"
      class="ml-auto body-link-md text-text-link underline halebop-focus mt-10 hover:text-text-link-hover hover:bg-surface-action-hover active:bg-surface-action-hover"
      @click="familyStore.ui.showFamilyDrawer = true"
      @keyup.enter.self.prevent="familyStore.ui.showFamilyDrawer = true"
      @keyup.space.self.prevent="familyStore.ui.showFamilyDrawer = true"
    >
      Ändra
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useMaxHeightAnimator } from '~/composables/general/useMaxHeightAnimator';
import type { AggregatedBundlePriceDto } from '~/models/ListingProduct.api.model';

const planStore = usePlanStore();
const familyStore = useFamilyStore();
const productPageStore = useMyProductPageStore();

const {
  setElementHeightCallback,
  animatedElementTransitionClasses,
  animatedElementRootClass,
} = useMaxHeightAnimator({ listenToResize: true });

const isFamilyPlanSetCopy = computed(() => productPageStore.isFamilyPlanSet);
const familyPlanSummaryItemsLength = computed(
  () =>
    productPageStore.productState.familyPlanDetails?.familyPlanSummaryItems
      ?.length ?? 0,
);
const familyPlanTableLoadingCopy = computed(
  () => productPageStore.ui.loading.isFamilySummaryTableLoading,
);

function getPlanName(plan: AggregatedBundlePriceDto, index: number): string {
  if (!plan.Plan?.IsFamilyPlan) {
    return planStore.selectPlanProductName(
      plan.Plan?.PlanId,
      plan.Plan?.PlanName,
    );
  }

  const items =
    productPageStore.productState.familyPlanDetails?.familyPlanSummaryItems ??
    [];

  const planIndex = items
    .slice(0, index + 1)
    .filter((item) => item.Plan?.IsFamilyPlan).length;
  return `Familjeabonnemang ${planIndex}`;
}

watch(
  [
    isFamilyPlanSetCopy,
    familyPlanSummaryItemsLength,
    familyPlanTableLoadingCopy,
  ],
  () => {
    setElementHeightCallback();
  },
);
</script>

<style lang="scss" scoped></style>
